export const projectFieldsByStep = [
  ["title", "category", "keywords", "links", "abstract", "summary"],
  [
    "beneficiaries",
    "equipment",
    "blockchain",
    "token",
    "timeline",
    "total_duration",
    "budgets",
    "total_budget",
  ],
  [
    "fundraising_method",
    "project_duration",
    "royalties",
    "attachment",
    "funding_goal",
    "collaborators_queue",
    "collaborators",
  ],
];
export const projectSteps = ["Basic Info", "Timeline & Budget", "Methods"];
export const chartBgColors = [
  "rgba(150, 45, 255)",
  "rgba(224, 198, 253)",
  "rgba(74, 58, 255)",
  "rgba(198, 210, 253)",
  "rgba(166, 67, 255)",
  "rgba(229, 215, 255)",
  "rgba(90, 71, 255)",
  "rgba(209, 219, 255)",
  "rgba(133, 48, 255)",
  "rgba(187, 176, 255)",
];

export const projectStateColor = {
  "Open Calls": "#8538FF",
  "Closed Call": "#9ca3af",
  "Successfully Funded": "#059669",
  "Ending Soon": "#fbbf24",
  "Nearly There": "#0284c7",
  Draft: "#3f3f3f",
};
